import type { IWatchlistable } from 'src/components/filmwebid/withWatchlistState';
import WatchlistSvg from 'src/components/svg/WatchlistSvg';
import classNames from 'classnames';
import styles from './WatchlistButton.module.css';

//#region [Styles]
// Converted to CSS Modules (WatchlistButton.module.css)
//#endregion

//#region [Props]
type WatchlistButtonProps = {
	className?: string;
} & IWatchlistable;
//#endregion

//#region [Component]
export default function WatchlistButton({ isWatchlisted, onWatchlistClick, className }: WatchlistButtonProps) {
	return <button onClick={onWatchlistClick} className={classNames(styles.SButton, className)}>
		<WatchlistSvg className={styles.SWatchlistIcon} selected={isWatchlisted} />
	</button>;
}
//#endregion
